import React from "react";
import PropTypes from "prop-types";

export default function ErrorInfoSVG({
  className,
  id,
  styles
}) {
  const {
    height,
    width,
    fill
  } = styles;

  return (
    <svg
      id={id || ''}
      className={className || ''}
      height={height || '13px'}
      width={width || '14px'}
      viewBox="0 0 14 13"
      version="1.1" xmlns="http://www.w3.org/2000/svg"xlink="http://www.w3.org/1999/xlink">
      <g id="Symbols" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="error-message-Full/mWeb" transform="translate(-5.000000, -33.000000)" fill="#FFFFFF">
          <g id="Icon/Alert/Error" transform="translate(5.000000, 33.000000)">
            <path d="M14.88,14h0l-7-12.12L.88,14ZM7.82,12.12a.57.57,0,1,1,0-1.14.57.57,0,0,1,0,1.14Zm.57-1.71H7.25V7H8.39v3.43Z" id="error-30px" fill={fill}></path>
          </g>
        </g>
      </g>
    </svg>
  );
}

ErrorInfoSVG.propTypes = {
  className: PropTypes.string,
  id: PropTypes.string,
  styles: PropTypes.shape({
    fill: PropTypes.string,
    height: PropTypes.string,
    width: PropTypes.string
  })
};

ErrorInfoSVG.defaultProps = {
  id: "",
  className: "",
  styles: {
    fill: "#FFFFFF",
    height: "13px",
    width: "14px"
  }
};
